import React, { useContext, useEffect, useState} from "react";
import { getDomainConfig } from "../../config/config";
import { useCart } from "../../hooks/useCart";
import CartItems from "../CartItems/CartItems";
import StandardFieldset from "../UI/StandardFieldset";
import StandardH2 from "../UI/StandardH2";
import { ABContext } from "../../contexts/ab-context";
import { BookingSiteOperated } from "../BookingSiteOparatedByComponent/BookingSiteOperatedBy";
import { useTranslation } from "react-i18next";
import { formatCurrency, getGeo } from "../../utils/formatCurrency";

const CartSummary = (props) => {

  const config = getDomainConfig();
  const geo = getGeo()

  const { t } = useTranslation('common');

 /* LOADING THE BRANDED SCSS */
 const [styles, setStyles] = useState(false);

 useEffect(() => {

const getStyles = async (theFileName, theFileEnd) => {
   if (config.brand) {
     let moduleStyles = false;
     try {
       moduleStyles = await import(
         "./" + theFileName + config.brand + theFileEnd
       );
       setStyles(moduleStyles);
     } catch (e) {
       console.error(
         `Styles for ${theFileName} could not be loaded, ${e.message}`
       );
     }
   }
 };

   // Specify file name and end of file name here.
   getStyles("CartSummary", ".module.scss");
 }, [config.brand]);

 /* END LOADING THE BRANDED SCSS */

  const abContext = useContext(ABContext);

  // AB tests
  const [isCro986, setIsCro986] = useState(false);

  useEffect(() => {
    if (abContext.cro986 !== undefined) setIsCro986(abContext.cro986.variant);
  }, [abContext]);

  // CRO-1381-checkout-redesign
  const [isCro1381, setIsCro1381] = useState(false);

  useEffect(() => {
    if ((config.brand !== 'Sw') && abContext.cro1381 !== undefined) setIsCro1381(abContext.cro1381.variant);
  }, [abContext]);
  // END CRO-1381-checkout-redesign

  let [showSummary, setShowSummary] = useState(false);
  let showHideHeadingClass = "ticketSummary ticketSummaryHide";
  let showHideTableClass = styles.hideMobile;

  if (showSummary) {
    showHideHeadingClass = "ticketSummary ticketSummaryOpen";
    showHideTableClass = styles.showMobile;
  }

  const { isSuccess: cartIsSuccess, data: cartContents } = useCart();

  let cartMeta = [];
  if (cartIsSuccess) {
    cartMeta = cartContents.meta;
  }

  return (
    <StandardFieldset id="booking-summary-pane" className="topFieldset">
      { isCro986 &&
      <div className="card card__green card__info">
        <p className='card_title'>Eligible for amendments and refunds</p>
        <p className='card_subtitle'>If your holiday arrangements change we can change your ticket start date even if they have been linked to My Disney Experience. We won’t charge an amendment fee.</p>
      </div>
      }
      { !isCro1381 &&
        <StandardH2 className={showHideHeadingClass}>
          <a
            href="#checkout-summary"
            onClick={(e) => {
              e.preventDefault();
              setShowSummary(!showSummary);
            }}
          >
            {t('ticket-summary')}
          </a>
        </StandardH2>
      }
      <table className={styles.table} id="checkout-summary">
        { !isCro1381 &&
          <thead className={!isCro1381 && showHideTableClass}>
            <tr className={styles.theadTr}>
              <th className={styles.qty}>{t('Qty')}</th>
              <th className={styles.item}>{t('Products')}</th>
              <th className={styles.price}>{t('Price')}</th>
            </tr>
          </thead>
        }
        <tbody className={!isCro1381 && showHideTableClass}>
          {!cartIsSuccess ?
            <div className={styles.loading_overlay}>
              <div className={styles.loading_circle}/>
            </div> :
            <CartItems
              currency={props.currency}
              geo={geo}
            />}
        </tbody>
        {!isCro1381 && (
          <tfoot className={styles.tfoot}>
            <tr className={styles.tfootTr}>
              <td colSpan="3" className={styles.subtotal}>
                <span>{t('Subtotal')} </span>
                <strong data-testid='tickets-subtotal'>{formatCurrency(cartMeta.total_price, geo)}</strong>
              </td>
            </tr>
          </tfoot>
        )}
      </table>
    {config.brand === 'Uo' ? <BookingSiteOperated/> : ''}
    </StandardFieldset>
  );
};

export default CartSummary;
